export const imageAction = (fileId, imageDisplay) => {
    return{
        type: 'changeImage',
        image: {
            id: fileId,
            display: imageDisplay
        }
    }
}